<app-field-label [label]="label() | translate" [required]="true"></app-field-label>
<mat-form-field class="w-100" appearance="outline">
    <mat-select [panelClass]="'custom-option-list'" disableOptionCentering [formControl]="timeZoneCtrl()">
        @for (timeZone of timeZoneKeyValueList(); track timeZone.key) {
            <mat-option [value]="timeZone.key">
                {{ timeZone.value }}
            </mat-option>
        }
    </mat-select>
    @if (timeZoneCtrl().invalid) {
        <mat-error>
            <app-invalid-label [label]="'time_zone' | translate"></app-invalid-label>
        </mat-error>
    }
</mat-form-field>
